export const SET_USER = 'SET_USER';

export const LOGIN = 'LOGIN';

export const LOGOUT = 'LOGOUT';

export const SIGNUP = 'SIGNUP';